module.exports = __webpack_public_path__ + "static/media/feat-barons-img1.a7226ff2.jpg";